import type { TFunction } from '!/i18n'
import { CategoryType, type TvCategoryEx } from '$/epg/categories'
import { produce } from 'immer'

export const translateCategory = (t: TFunction) => (category: TvCategoryEx) =>
  produce(category, (draft) => {
    if (draft.type === CategoryType.Favorite) {
      draft.name = t('favorites')
    } else if (draft.type === CategoryType.All) {
      draft.name = t('all')
    } else if (draft.type === CategoryType.Featured) {
      draft.name = t('featured')
    }
  })
